import { DOCUMENT } from '@angular/common';
import { EventEmitter, Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

export interface ITheme {
  name?:string,
  baseColor?: string,
  isActive?: boolean
}


@Injectable({
  providedIn: 'root'
})
export class ThemesService {

  public onThemeChange: EventEmitter<ITheme> = new EventEmitter();

  private renderer: Renderer2;
  public activatedTheme: ITheme;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    renderFactory: RendererFactory2) { 
      this.renderer = renderFactory.createRenderer(null,null);
    }

    applyTheme(prevTheme,themeName){
      this.renderer.removeClass(this.document.body,prevTheme)
      this.renderer.addClass(this.document.body, themeName);
    }
   
    applyConfig(color: string){
      this.renderer.addClass(this.document.body, color);
    }

}
